import { ActionsJobs } from "../../../Actions/ActionsJobs/ActionsJobs";

export const onFetchAndSaveJobs = (organizationId) => {
  ActionsJobs.fetchAndSaveJobs(organizationId);
};
